import React, { useState, useEffect } from "react";
import icon1 from "../../../assets/social-security-icons/social-security-vs-fra.svg";
import timeIcon from "../../../assets/social-security-icons/time-remaing-retirement.svg";
import { ToolTipCreator } from "../../../helpers/ToolTipCreator";
import backIcon from "../../../assets/social-security-icons/backIcon.svg";
import { SocialSecurityFormFields } from "./SocialSecurityFormFields";
import { NumberCardSkeleton } from "../../Skeletons/DebtSkeleton";
import { Table } from "antd";
import { useHistory } from "react-router-dom";
import "../styles/socialSecurity.css";
import { SocialSecurityHardCodeFields } from "./SocialSecurityHardCodeFields";
import {
  ageAtBreakeven,
  buildEarlyRetirementTable,
  calculateRetirementAge,
  futureValuePreFRA,
  monthlyBenefit,
  monthsBeforeFRA,
  monthsToBreakeven,
  monthsToBreakevenWithCOLA,
  percentOfFRA,
  preFRABenefit,
} from "../../../helpers/EarlyvsFRACalculation";
import { formatCurrencyAmount } from "../../../helpers/formatAmount";
import { MODULE_API } from "../../../apis";
import { calculateSocialSecurityResults } from "../../../helpers/socialSecurityCalculations";
import { SocialSecurityFormSkeleton } from "../../InsuranceNew/InsuraceDashboardComponents/SocialSecurityFormSkeleton";
import NewLoader from "../../../components/styled-components/loader/NewLoader";
import CombinedSocialSecurityTable from "./CombinedSocialSecurityTable";

export const SocialSecurityFRA = () => {
  const history = useHistory();
  const [loading, setLoading] = useState(false);
  const [formData, setFormData] = useState(null);
  const [results, setResults] = useState(null);
  const [userEntryResults, setUserEntryResults] = useState(null);
  const [socialFieldsData, setSocialFieldsData] = useState(null);
  const [tableData, setTableData] = useState(null);

  const [loadingAttributes, setLoadingAttributes] = useState(false);
  const [attributes, setAttributes] = useState(null);
  const module = "Social Security Early";

  const moduleDataToFetch = "Social Security Calculator";

  const handleChange = (name, value) => {
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const formFields = [
    {
      label: "Enter years",
      type: "number",
      name: "years",
    },
    {
      label: "Enter months",
      type: "number",
      name: "months",
    },
  ];
  const resultArray = [
    {
      id: 1,
      name: "Time until Full Retirement Age",
      icon: timeIcon,
      value:
        formData && formData["Enter Years"]
          ? calculateRetirementAge(
              formData["Enter Years"],
              formData["Enter Months"] || 0
            )
          : "N/A",
    },
  ];
  const columns = [
    {
      title: "Early Start Age",
      dataIndex: "Age to take Social Secuity",
      key: "Age to take Social Secuity",
      align: "center",
      render: (val) => val || "N/A",
    },
    {
      title: "Months before FRA",
      dataIndex: "Months from Full Retirement Age",
      key: "Months from Full Retirement Age",
      align: "center",
      render: (val) => val || "N/A",
    },
    {
      title: "% of FRA",
      dataIndex: "% of FRA Benefit",
      key: "% of FRA Benefit",
      align: "center",
      render: (val) => (val ? `${val}%` : "N/A"),
    },
    {
      title: "Monthly Benefit",
      dataIndex: "Monthly Benefit",
      key: "Monthly Benefit",
      align: "center",
      render: (val) => (val ? formatCurrencyAmount(val) : "N/A"),
    },
    {
      title: (
        <div className="social-security-table-heading">
          Break-even without TVM Interest
        </div>
      ),
      children: [
        {
          title: "Pre-FRA Benefit",
          dataIndex: "Total benefit received up to Age 70",
          key: "Total benefit received up to Age 70",
          align: "center",
          render: (val) => (val ? formatCurrencyAmount(val) : "N/A"),
        },
        {
          title: "Months to break-even",
          dataIndex: "Months to break-even with age 70",
          key: "Months to break-even with age 70",
          align: "center",
          render: (val) => val || "N/A",
        },
        {
          title: "Age at break-even",
          dataIndex: "Age at break-even-formated",
          key: "Age at break-even-formated",
          align: "center",
          render: (val) => val || "N/A",
        },
      ],
    },
    {
      title: (
        <div className="social-security-table-heading">
          Break-even with TVM and COLA
        </div>
      ),
      children: [
        {
          title: "Future value at FRA of pre-FRA Benefit",
          dataIndex: "Future value at 70 of pre-70 benefit",
          key: "Future value at 70 of pre-70 benefit",
          align: "center",
          render: (val) => (val ? formatCurrencyAmount(val) : "N/A"),
        },
        {
          title: "Months to break-even",
          dataIndex: "Months to break-even with age 70 (COLA)",
          key: "Months to break-even with age 70 (COLA)",
          align: "center",
          render: (val) => val || "N/A",
        },
        {
          title: "Age at break-even",
          dataIndex: "Age at Break-even-COLA-formated",
          key: "Age at Break-even-COLA-formated",
          align: "center",
          render: (val) => val || "N/A",
        },
      ],
    },
  ];

  const allResults = [
    {
      id: 1,
      name: "Months before FRA",
      value: userEntryResults ? userEntryResults.monthsEarly : "N/A",
    },
    {
      id: 2,
      name: "% of FRA",
      value: userEntryResults ? userEntryResults.pct : "N/A",
    },
    {
      id: 3,
      name: "Monthly benefit ",
      value: userEntryResults
        ? formatCurrencyAmount(userEntryResults.earlyBenefit)
        : "N/A",
    },
    {
      id: 4,
      name: "Pre-FRA Benefit",
      value: userEntryResults
        ? formatCurrencyAmount(userEntryResults.preFRA)
        : "N/A",
    },
    {
      id: 5,
      name: "Months to break-even",
      value: userEntryResults ? userEntryResults.monthsBE : "N/A",
    },
    {
      id: 6,
      name: "Age at break-even",
      value: userEntryResults
        ? userEntryResults.ageBE && userEntryResults.ageBE.decimal.toFixed(2)
        : "N/A",
    },
    // {
    //   id: 9,
    //   name: "Future Pre-FRA Benefit",
    //   value: userEntryResults
    //     ? formatCurrencyAmount(userEntryResults.fvPreFRA)
    //     : "N/A",
    // },
    // {
    //   id: 10,
    //   name: "Months to break-even",
    //   value: userEntryResults ? userEntryResults.monthsBE_COLA : "N/A",
    // },
    // {
    //   id: 11,
    //   name: "Age at break-even",
    //   value: userEntryResults
    //     ? userEntryResults.ageBE_COLA &&
    //       userEntryResults.ageBE_COLA.decimal.toFixed(2)
    //     : "N/A",
    // },
    {
      id: 12,
      name: "Combined Benefit at Chosen Ages",
      value: results
        ? results.combined && formatCurrencyAmount(results.combined)
        : "$0.00",
    },
    {
      id: 13,
      name: "Monthly Benefit Combine at FRA",
      value: results
        ? results.fraCombined && formatCurrencyAmount(results.fraCombined)
        : "$0.00",
    },
    {
      id: 14,
      name: "Combine Monthly Tax on Benefits at desire Age",
      value: results
        ? results.taxable && formatCurrencyAmount(results.taxable)
        : "$0.00",
    },
    {
      id: 15,
      name: "Combine Monthly Tax on Benefits at FRA",
      value: results
        ? results.fraTaxable && formatCurrencyAmount(results.fraTaxable)
        : "$0.00",
    },
  ];

  const fetchData = async () => {
    try {
      setLoading(true);
      const res = await MODULE_API.fetchItems({
        moduleName: moduleDataToFetch,
        pageNum: 1,
        limit: 10,
        body: {},
      });
      // console.log("resssssss", res);
      if (res && res.records && res.records.length > 0) {
        setSocialFieldsData(res.records[0]);
        const socialData = res.records[0];
        const resultsAll = calculateSocialSecurityResults(res.records[0]);
        setResults(resultsAll);
        return socialData;
      }
    } catch (error) {
      console.error("Error fetching attributes", error);
    } finally {
      setLoading(false);
    }
  };

  // useEffect(() => {
  //   if (formData && formData.years && formData.months) {
  //     const FRA_YEARS = 67,
  //       FRA_MONTHS = 0;
  //     const START_YEARS = formData.years,
  //       START_MONTHS = formData.months;
  //     const FRA_BENEFIT =
  //       (socialFieldsData &&
  //         socialFieldsData["Your Monthly Benefit at FRA ($)"]) ||
  //       0; // baseline at FRA
  //     const COLA = 0.02; // 2%
  //     const monthsEarly = monthsBeforeFRA(
  //       FRA_YEARS,
  //       FRA_MONTHS,
  //       START_YEARS,
  //       START_MONTHS
  //     );
  //     const pct = percentOfFRA(monthsEarly);
  //     const earlyBenefit = monthlyBenefit(FRA_BENEFIT, monthsEarly);
  //     const preFRA = preFRABenefit(earlyBenefit, monthsEarly);
  //     const monthsBE = monthsToBreakeven(FRA_BENEFIT, earlyBenefit, preFRA);
  //     const ageBE = ageAtBreakeven(START_YEARS, START_MONTHS, monthsBE);

  //     // With COLA
  //     const fvPreFRA = futureValuePreFRA(earlyBenefit, monthsEarly, COLA);
  //     const monthsBE_COLA = monthsToBreakevenWithCOLA(
  //       FRA_BENEFIT,
  //       earlyBenefit,
  //       fvPreFRA
  //     );
  //     const ageBE_COLA = ageAtBreakeven(
  //       START_YEARS,
  //       START_MONTHS,
  //       monthsBE_COLA
  //     );
  //     const userEntryBasedResults = {
  //       monthsEarly,
  //       pct: (pct * 100).toFixed(2) + "%",
  //       earlyBenefit,
  //       preFRA,
  //       monthsBE,
  //       ageBE,
  //       fvPreFRA,
  //       monthsBE_COLA,
  //       ageBE_COLA,
  //     };
  //     console.log("early VS FRA", userEntryBasedResults);
  //     setUserEntryResults(userEntryBasedResults);
  //     const tableDataAll = buildEarlyRetirementTable(
  //       FRA_YEARS,
  //       FRA_MONTHS,
  //       FRA_BENEFIT,
  //       COLA
  //     );
  //     setTableData(tableDataAll);
  //   }
  // }, [formData]);

  const fetchModuleData = async (module, socialData) => {
    try {
      setLoading(true);
      const res = await MODULE_API.fetchItems({
        moduleName: module,
        pageNum: 1,
        limit: 10,
        body: {},
      });
      // console.log("resssssss", res);
      if (res && res.records && res.records.length > 0) {
        setFormData(res.records[0]);
        const data = res.records[0];

        if (data && data["Enter Years"]) {
          const FRA_YEARS = 67,
            FRA_MONTHS = 0;
          const START_YEARS = data["Enter Years"],
            START_MONTHS = data["Enter Months"] || 0;
          const FRA_BENEFIT =
            (socialFieldsData &&
              socialFieldsData["Your Monthly Benefit at FRA ($)"]) ||
            (socialData && socialData["Your Monthly Benefit at FRA ($)"]) ||
            0; // baseline at FRA
          const COLA = 0.02; // 2%
          const monthsEarly = monthsBeforeFRA(
            FRA_YEARS,
            FRA_MONTHS,
            START_YEARS,
            START_MONTHS
          );
          const pct = percentOfFRA(monthsEarly);
          const earlyBenefit = monthlyBenefit(FRA_BENEFIT, monthsEarly);
          const preFRA = preFRABenefit(earlyBenefit, monthsEarly);
          const monthsBE = monthsToBreakeven(FRA_BENEFIT, earlyBenefit, preFRA);
          const ageBE = ageAtBreakeven(
            START_YEARS,
            START_MONTHS,
            monthsBE,
            FRA_YEARS
          );

          // With COLA
          const fvPreFRA = futureValuePreFRA(earlyBenefit, monthsEarly, COLA);
          const monthsBE_COLA = monthsToBreakevenWithCOLA(
            FRA_BENEFIT,
            earlyBenefit,
            fvPreFRA
          );
          const ageBE_COLA = ageAtBreakeven(
            START_YEARS,
            START_MONTHS,
            monthsBE_COLA,
            FRA_YEARS
          );
          const userEntryBasedResults = {
            monthsEarly,
            pct: (pct * 100).toFixed(2) + "%",
            earlyBenefit,
            preFRA,
            monthsBE,
            ageBE,
            fvPreFRA,
            monthsBE_COLA,
            ageBE_COLA,
          };
          console.log("early VS FRA", userEntryBasedResults);
          setUserEntryResults(userEntryBasedResults);
          const tableDataAll = buildEarlyRetirementTable(
            FRA_YEARS,
            FRA_MONTHS,
            FRA_BENEFIT,
            COLA
          );
          console.log("table", tableDataAll, data);
          setTableData(tableDataAll);
        }
      }
    } catch (error) {
      console.error("Error fetching attributes", error);
    } finally {
      setLoading(false);
    }
  };
  // Fetch Social Security fields
  const getFields = async (Name) => {
    setLoadingAttributes(true);
    try {
      const res = await MODULE_API.assetFiledDetails(Name);
      if (res && res.attributes) {
        const allAttributes = [...res.attributes];
        const sortedAttributes =
          allAttributes &&
          allAttributes.sort(
            (a, b) => a.groupPriorityValue - b.groupPriorityValue
          );
        setAttributes(sortedAttributes);
      }
    } finally {
      setLoadingAttributes(false);
    }
  };
  const createAttributes = async () => {
    try {
      setLoading(true);
      const result = await MODULE_API.addAsset(module, {
        clientModules: [formData],
      });
      await fetchModuleData(module);
      setLoading(false);
    } catch (error) {
      setLoading(false);
    }
  };
  const updateRecord = async () => {
    try {
      setLoading(true);
      await MODULE_API.updateClientModule(formData.id, {
        ...formData,
      });
      await fetchModuleData(module);
      setLoading(false);
    } catch (error) {
      console.error("Error updating record", error);
    } finally {
      setLoading(false);
    }
  };
  const fetchAll = async () => {
    const socialData = await fetchData();
    await fetchModuleData(module, socialData);
  };
  useEffect(() => {
    getFields(module);
    fetchAll();
  }, []);

  const handleCalculate = () => {
    if (!formData || !formData["Enter Years"]) return;
    if (formData && formData.id) {
      updateRecord();
    } else {
      createAttributes();
    }
    if (formData && formData["Enter Years"]) {
      const FRA_YEARS = 67,
        FRA_MONTHS = 0;
      const START_YEARS = formData["Enter Years"],
        START_MONTHS = formData["Enter Months"] || 0;
      const FRA_BENEFIT =
        (socialFieldsData &&
          socialFieldsData["Your Monthly Benefit at FRA ($)"]) ||
        0; // baseline at FRA
      const COLA = 0.02; // 2%
      const monthsEarly = monthsBeforeFRA(
        FRA_YEARS,
        FRA_MONTHS,
        START_YEARS,
        START_MONTHS
      );
      const pct = percentOfFRA(monthsEarly);
      const earlyBenefit = monthlyBenefit(FRA_BENEFIT, monthsEarly);
      const preFRA = preFRABenefit(earlyBenefit, monthsEarly);
      const monthsBE = monthsToBreakeven(FRA_BENEFIT, earlyBenefit, preFRA);
      const ageBE = ageAtBreakeven(
        START_YEARS,
        START_MONTHS,
        monthsBE,
        FRA_YEARS
      );

      // With COLA
      const fvPreFRA = futureValuePreFRA(earlyBenefit, monthsEarly, COLA);
      const monthsBE_COLA = monthsToBreakevenWithCOLA(
        FRA_BENEFIT,
        earlyBenefit,
        fvPreFRA
      );
      const ageBE_COLA = ageAtBreakeven(
        START_YEARS,
        START_MONTHS,
        monthsBE_COLA,
        FRA_YEARS
      );
      const userEntryBasedResults = {
        monthsEarly,
        pct: (pct * 100).toFixed(2) + "%",
        earlyBenefit,
        preFRA,
        monthsBE,
        ageBE,
        fvPreFRA,
        monthsBE_COLA,
        ageBE_COLA,
      };
      console.log("early VS FRA", userEntryBasedResults);
      setUserEntryResults(userEntryBasedResults);
      const tableDataAll = buildEarlyRetirementTable(
        FRA_YEARS,
        FRA_MONTHS,
        FRA_BENEFIT,
        COLA
      );
      console.log("table", tableDataAll, formData);
      setTableData(tableDataAll);
    }
  };

  console.log("userrrrrrrr", userEntryResults);

  return (
    <div className="social-security-main">
      <div
        className="social-security-back-container"
        onClick={() => {
          history.push("/planner/social-security");
        }}
      >
        <div className="social-security-back-icon-container">
          <img width={16} height={16} src={backIcon} alt={"back Icon"}></img>
        </div>
        {/* {moduleData.name} */}
        <div className="social-security-back-text">Back to Social Security</div>
      </div>
      <div className="social-security-main-heading-container">
        <div className="social-security-icon-container">
          <img
            width={32}
            height={32}
            src={icon1}
            alt={"Retirement Calculator"}
          ></img>
        </div>
        {/* {moduleData.name} */}
        <div className="social-security-main-heading">
          Social Security Early vs Starting at Full Retirement Age
          <ToolTipCreator name={"retirement_earnings_tooltip"} />
        </div>
      </div>
      <div className="social-security-calculator-content-main">
        <div className="social-security-calculator-content-form-container">
          <div className="social-security-sub-heading">
            Your Full Retirement Age is 67 Years and 0 Months.
          </div>
          <div className="social-security-sub-title">
            Enter age before FRA to take Social Security
          </div>
          {loadingAttributes ? (
            <SocialSecurityFormSkeleton rows={1} />
          ) : (
            <SocialSecurityFormFields
              formFields={attributes && attributes}
              formData={formData && formData}
              onChange={handleChange}
            />
          )}
          <button
            className="social-security-calculator-submit-button"
            onClick={(e) => {
              e.preventDefault();
              handleCalculate();
            }}
            disabled={loading || loadingAttributes || !formData}
          >
            Apply
          </button>
        </div>
        <div className="social-security-calculator-results">
          <h3>Results</h3>
          <div className="social-security-result-tag-container">
            {resultArray &&
              resultArray.map((item, index) => (
                <div
                  key={index}
                  className="social-security-main-heading-container"
                >
                  <div className="social-security-result-icon-container">
                    <img
                      width={32}
                      height={32}
                      src={item.icon}
                      alt={item.name}
                    ></img>
                  </div>
                  <div className="social-security-results-main">
                    <div className="social-result-heading">{item.name} </div>
                    <div className="social-result-value">
                      {" "}
                      {loading ? <NumberCardSkeleton /> : item.value}{" "}
                    </div>
                  </div>
                </div>
              ))}
          </div>
        </div>
      </div>
      <div className="retirement-calculator-main">
        <div className="social-security-main-heading-container">
          {/* {moduleData.name} */}
          <div className="social-security-main-heading">
            Breakdown of the results
          </div>
        </div>
        <div
          className="social-security-calculator-content-main"
          style={{ position: "relative" }}
        >
          <CombinedSocialSecurityTable
            tableData={tableData && tableData}
            cols={columns}
          />
          <NewLoader isLoading={loading} />
        </div>
        <div
          className="summary-section-container"
          style={{
            alignItems: "baseline",
            // justifyContent: "center",
            flexWrap: "wrap",
            borderRadius: "8px",
            gap: "8px",
          }}
        >
          <div style={{ minWidth: "fit-content", width: "17%" }}>
            <div
              className="summary-section"
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                border: "none",
              }}
            >
              <div className="total-summary-section">
                <h2 className="total-summary">Results</h2>
              </div>
              <div className="average-budget-summary-section">
                <h2 className="average-budget-summary">Your Entry</h2>
              </div>
            </div>
          </div>
          <div
            style={{
              display: "flex",
              gap: "8px",
              flexWrap: "wrap",
              width: "82%",
            }}
          >
            {allResults &&
              allResults.map((item, index) => (
                <div
                  key={index}
                  className="amount-spend-section"
                  style={{
                    borderLeft: "1px solid #d1d5db",
                    padding: "8px",
                    width: "18%",
                    textAlign: "center",
                  }}
                >
                  <div className="amount-spend-title-section">
                    <h2 className="spend-amount-title">{item.name}</h2>
                  </div>
                  <div className="spend-amount-amount-section">
                    <h2 className="spend-amount-amount">
                      {loading ? <NumberCardSkeleton /> : item.value}
                    </h2>
                  </div>
                </div>
              ))}
          </div>
        </div>
      </div>
    </div>
  );
};
